import { z } from 'zod';

export const userSchema = z.object({
  id: z.string(),
  name: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  initials: z.string().nullable(),
  email: z.string(),
  highbondId: z.string(),
  locale: z.string(),
  timezone: z.string(),
  dateFormat: z.string().optional().nullable(),
  termsOfService: z.boolean().optional().nullable(),
  userType: z.string().nullable().optional(),
  createdAt: z.number().transform((date) => new Date(date).toISOString()),
  updatedAt: z.number().transform((date) => new Date(date).toISOString()),
});

export type UserEntity = z.infer<typeof userSchema>;
export type User = Omit<UserEntity, 'id' | 'createdAt' | 'updatedAt'>;
export type UserDto = Pick<
  UserEntity,
  'id' | 'highbondId' | 'name' | 'email' | 'createdAt' | 'updatedAt'
>;

export type UserMetadata = {
  id: string;
  isDeleted: boolean;
  eventTime: Date;
} | null;
export type UserMinimalData = Pick<
  UserEntity,
  | 'id'
  | 'name'
  | 'email'
  | 'highbondId'
  | 'createdAt'
  | 'updatedAt'
  | 'lastName'
  | 'initials'
  | 'firstName'
>;

export const minimalUserSchema = userSchema.pick({
  id: true,
  name: true,
  email: true,
  initials: true,
});
export type MinimalUserEntity = z.infer<typeof minimalUserSchema>;

export const watcherUserSchema = userSchema.pick({
  id: true,
  name: true,
  email: true,
  initials: true,
});
export type WatcherUserEntity = z.infer<typeof watcherUserSchema>;
